import React from "react"
import { GatsbyImage,StaticImage } from "gatsby-plugin-image"
import parse from "html-react-parser"
import "../css/@wordpress/block-library/build-style/style.css"
import "../css/@wordpress/block-library/build-style/theme.css"
import { Link } from "gatsby"

const UpdateTeaser = ({ data }) => {
  const featuredImage = {
    data: data.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData,
    alt: data.featuredImage?.node?.alt || ``,
  }

  return (
    <div className="inner">
      <div className="featured-img">
        {
          !featuredImage.data && <StaticImage src="../assets/no-image.jpg" alt="logo" />
        }
        {featuredImage?.data && (
          <Link to={data.uri.replace(/\/$/, '')} style={{ zIndex: '9999' }}>
            <GatsbyImage
              image={featuredImage.data}
              alt={featuredImage.alt || ``}
              style={{ zIndex: '9998' }}
            />
          </Link>
        )}
      </div>

      <div className="desc">
        <span>{data.date}</span>
        <h2>
          <a href={data.uri.replace(/\/$/, '')}>
            <strong>{parse(data.title)}
            </strong>
          </a>
        </h2>
        {!!data.excerpt && (
          <div className="excerpt">
            <div>
              {(data.excerpt.length > 120) ? parse(data.excerpt.substring(0, 120) + "...") : parse(data.excerpt)}
            </div>
            <div style={{ textAlign: 'right' }}>
              <a href={data.uri.replace(/\/$/, '')} className='teaserlink'>...more</a>
            </div>
          </div>
        )}
      </div>
    </div>

  )
}

export default UpdateTeaser

